import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import useFocusTrap from '../../shared/custom-hooks/useFocusTrap';

const FocusTrapButton = styled.button`
  ${tw`absolute opacity-0 -top-full -left-full`};
`;

const Modal = ({ children, close }) => {
  const elRef = useRef(null);
  const lastActiveRef = useRef(null);

  const { firstTrapRef, lastTrapRef } = useFocusTrap(close, lastActiveRef);

  if (!elRef.current) {
    const div = document.createElement('div');
    elRef.current = div;
  }

  useEffect(() => {
    const modalRoot = document.getElementById('modal');

    modalRoot.appendChild(elRef.current);
    return () => modalRoot.removeChild(elRef.current);
  }, []);

  return createPortal(
    <>
      <FocusTrapButton ref={firstTrapRef} tabIndex={0} aria-hidden="true" />
      {children}
      <FocusTrapButton ref={lastTrapRef} tabIndex={0} aria-hidden="true" />
    </>,
    elRef.current
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  close: PropTypes.func.isRequired,
};

export default Modal;
